import { useAtom } from '@reatom/npm-react'

import { balanceVisibleAtom } from '../atoms'

export const useVisibilityFormatter = (hiddenPlaceholder: string = '****') => {
  const [isVisible] = useAtom(balanceVisibleAtom)

  return <T>(content: T) => (isVisible ? content : hiddenPlaceholder)
}
